import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface KeyboardShortcutsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function KeyboardShortcutsDialog({ open, onOpenChange }: KeyboardShortcutsDialogProps) {
  const shortcuts = [
    { keys: ["⌘/Ctrl", "Z"], action: "Undo last change" },
    { keys: ["⌘/Ctrl", "Shift", "Z"], action: "Redo" },
    { keys: ["⌘/Ctrl", "D"], action: "Duplicate selected block" },
    { keys: ["⌘/Ctrl", "G"], action: "Toggle grid visibility" },
    { keys: ["Del"], action: "Delete selected block(s)" },
    { keys: ["⌘/Ctrl", "+"], action: "Zoom in" },
    { keys: ["⌘/Ctrl", "-"], action: "Zoom out" },
    { keys: ["⌘/Ctrl", "0"], action: "Reset zoom to 100%" },
    { keys: ["Esc"], action: "Deselect all blocks" },
    { keys: ["⌘/Ctrl", "Click"], action: "Multi-select blocks" },
    { keys: ["?"], action: "Show keyboard shortcuts" },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Keyboard Shortcuts ⌨️</DialogTitle>
          <DialogDescription>Work faster with these handy shortcuts</DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-4">
          {shortcuts.map((shortcut, index) => (
            <div key={index} className="flex items-center justify-between">
              <span className="text-sm">{shortcut.action}</span>
              <div className="flex items-center gap-1">
                {shortcut.keys.map((key, keyIndex) => (
                  <kbd
                    key={keyIndex}
                    className="px-2 py-1 text-xs bg-muted border border-border rounded"
                  >
                    {key}
                  </kbd>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-xs text-muted-foreground pt-2 border-t">
          <p>💡 Tip: Hover over any toolbar button to see its tooltip</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
